import { Stack, SxProps, Theme, useScrollTrigger } from '@mui/material';
import { ReactNode } from 'react';

interface Props {
  children: ReactNode;
  sx?: SxProps<Theme>;
}

const TopNavigation = ({ children, sx }: Props) => {
  const trigger = useScrollTrigger({ threshold: 0, disableHysteresis: true });

  return (
    <Stack
      sx={[
        {
          position: 'fixed',
          py: { xs: 2, md: 0 },
          px: { xs: 2, md: 2 },
          minHeight: { md: 56 },
          maxHeight: { md: 56 },
          bgcolor: trigger ? 'background.default' : 'transparent',
          borderBottom: trigger ? '1px solid' : 'none',
          borderColor: 'grey.800',
          width: '100%',
          zIndex: 1,
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'space-between',
        },
        (theme) => ({
          transition: theme.transitions.create(['background-color']),
        }),
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
    >
      {children}
    </Stack>
  );
};

export default TopNavigation;
